"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * An error thrown by our fetch implementation. It allows for inspection
 * of a response if present. Typically thrown when response has a status
 * code > 399 and <= 599, but could also be thrown when connectivity is
 * an issue.
 */

class FetchError extends Error {
  constructor(status, msg, response, originalError) {
    super(msg);
    this.status = status;
    this.response = response;
    this.originalError = originalError;
  }

}

exports.default = FetchError;